exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../Styles/counter.css"), undefined);

// module
exports.push([module.id, ".timecode___timecode___2O9vb {\n}\n\n.timecode___timecode___2O9vb:hover {\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"timecode": "timecode___timecode___2O9vb " + require("-!../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../Styles/counter.css").locals["counter"] + ""
};